import { QueryableTargetField, DocumentType } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllQueryableTargetFields = () =>
  getAllEnumOptions(QueryableTargetField)

export const getAllQueryableTargetFieldsForDocumentType = (
  documentType: DocumentType,
) => {
  let options = [
    QueryableTargetField.DocumentId,
    QueryableTargetField.DocumentExternalId,
  ]
  if (documentType === DocumentType.Incident)
    options = [
      QueryableTargetField.DocumentId,
      QueryableTargetField.DocumentExternalId,
      QueryableTargetField.IncidentNumber,
    ]
  else if (documentType === DocumentType.EmergencyResource)
    options = [
      QueryableTargetField.DocumentId,
      QueryableTargetField.DocumentExternalId,
      QueryableTargetField.UnitIdentification,
    ]

  const test = Object.keys(QueryableTargetField).filter(key => {
    return !isNaN(parseInt(key)) && options.indexOf(parseInt(key)) > -1
  })
  return test.map(key => ({
    key,
    label: QueryableTargetField[key as any],
    value: key,
  }))
}

export const getDefaultQueryableTargetFieldForDocumentType = (
  documentType: DocumentType,
) => QueryableTargetField.DocumentExternalId

export const getQueryableTargetFieldLabel = (key?: QueryableTargetField) => {
  if (key === null || typeof key === 'undefined') return ''

  return QueryableTargetField[key]
}
